import type { LayerKey } from '@festina-life/api'
import { useMemo } from 'react'

import { useMetaModelContext } from '../../context/metaModelContext'
import { useLazyLayerMetaModel } from '../../context/useLazyLayerMetaModel'
import { type EnumMetaType, isEnumMetaType } from '../../types/metaModel'
import { getApplicationViewConfiguredEnums } from '../../workspace/helpers'
import { useOperationsContext } from '../../workspace/operationsContext'

export const useNonConfiguredModeledEnums = (
  layer: LayerKey,
  block: string,
) => {
  const { configuredEnums } = useOperationsContext()
  const { layerTopology, blockTopology } = useMetaModelContext()
  const metaModel = useLazyLayerMetaModel(layer.layerId)

  return useMemo(() => {
    const configuredEnumsOnLayer = getApplicationViewConfiguredEnums({
      configuredEnums,
      block,
      layer,
      layerTopology,
      blockTopology,
    })
    const allNonConfiguredEnums = new Map<string, EnumMetaType>()

    metaModel?.types?.forEach((metaType) => {
      if (
        isEnumMetaType(metaType) &&
        !configuredEnumsOnLayer?.has(metaType.typeName)
      ) {
        allNonConfiguredEnums.set(metaType.typeName, metaType)
      }
    })

    return Array.from(allNonConfiguredEnums.keys()).sort((enumA, enumB) =>
      enumA.localeCompare(enumB, undefined, { sensitivity: 'base' }),
    )
  }, [
    configuredEnums,
    layerTopology,
    blockTopology,
    metaModel.types,
    layer,
    block,
  ])
}
